import { ref, deleteObject, getDownloadURL, uploadBytesResumable } from 'firebase/storage';

import { firebaseStorage } from './firebase';

export async function uploadImage(file: File, path: string): Promise<string> {
  const uniqueFilename = `${Date.now()}-${file.name}`;
  const storageRef = ref(firebaseStorage, `${path}/${uniqueFilename}`);
  const uploadTask = uploadBytesResumable(storageRef, file);

  await new Promise((resolve, reject) => {
    uploadTask.on(
      'state_changed',
      null,
      (error) => reject(error),
      () => resolve(uploadTask.snapshot)
    );
  });

  return getDownloadURL(uploadTask.snapshot.ref);
}

export async function deleteImage(url: string) {
  try {
    const storageRef = ref(firebaseStorage, url);
    await deleteObject(storageRef);
  } catch (error) {
    console.error('Error deleting image:', error);
  }
}
